var map = {
	"./Population.svg": 6824,
	"./Variation.svg": 7881,
	"./analysis.svg": 4024,
	"./blast copy.svg": 2508,
	"./blast.svg": 8743,
	"./browse.svg": 6512,
	"./dna.svg": 3119,
	"./download.svg": 2058,
	"./fst.svg": 6796,
	"./go.svg": 8160,
	"./gwas.svg": 5874,
	"./gwas1.svg": 9721,
	"./home.svg": 2891,
	"./kegg.svg": 399,
	"./language.svg": 3921,
	"./msa.svg": 4927,
	"./peo.svg": 9034,
	"./pi.svg": 8352,
	"./qtl.svg": 9109,
	"./search.svg": 9486,
	"./search1.svg": 1416,
	"./sequence.svg": 2896,
	"./sequence1.svg": 503,
	"./structure.svg": 7789,
	"./tools.svg": 2161
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1620;